import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import _ from 'lodash'

import Operations from '../../../../operations'
import { IncidentReport } from '../../../../components/reports'
import { withRouter } from '../../../../withRouter'

export function HomeIncidents(props) {
  const {
    data,
    error,
    fetchData,
    isLoading,
    router: { params },
  } = props

  useEffect(() => {
    fetchData(params.id)
  }, [params.id])

  return (
    <div style={styles.reportContainer}>
      <IncidentReport
        title={'Incidents'}
        backLink={`/homes/${params.id}/dashboard`}
        data={data}
        isLoading={isLoading}
        error={error}
        emptyText={'This site has no Incidents to display.'}
        chartHeight={400}
      />
    </div>
  )
}

const styles = {
  reportContainer: {
    margin: '0 auto',
    maxWidth: 960,
    padding: '30px 0px 80px 0px',
    position: 'relative',
  },
}

HomeIncidents.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    data: _.get(state, `data.requests.${STATE_ID}.response`),
    isLoading: _.get(state, `data.requests.${STATE_ID}.isLoading`),
    error: _.get(state, `data.requests.${STATE_ID}.error`),
  }
}
const STATE_ID = 'home_incidents'
const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (id) => {
      dispatch(
        Operations.fetchData({
          url: 'aggregations/incidents',
          query: { home: id },
          id: STATE_ID,
        })
      )
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HomeIncidents))
